import { Button } from "@mui/material"; // Importa el componente Button de Material UI
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'; // Importa el ícono de flecha hacia atrás de la librería de íconos de Material UI
import { useNavigate } from "react-router-dom"; // Importa el hook 'useNavigate' para manejar la navegación entre rutas

export default function Koch() { // Define el componente funcional Koch
  const navigate = useNavigate(); // Inicializa el hook de navegación para redirigir a otras rutas
      
  // Define los estilos para el iframe que contiene el reproductor de SoundCloud
  const iframeStyles = {
    width: '100%', // Establece el ancho del iframe al 100% del contenedor
    height: '100%', // Establece la altura del iframe al 100% del contenedor
    scrolling: 'no', // Desactiva el desplazamiento dentro del iframe
    frameborder: 'no', // Elimina el borde del iframe
    allow: 'autoplay', // Permite la reproducción automática del contenido dentro del iframe
  };

  // Define los estilos para el contenedor principal
  const containerStyles = {
    backgroundColor: 'rgb(97, 185, 207)', // Establece el color de fondo del contenedor
    height: '381px', // Define la altura del contenedor
    left: '361px', // Define la posición horizontal del contenedor
    position: 'absolute', // Establece la posición como absoluta
    top: '232px', // Define la posición vertical del contenedor
    width: '788px', // Define el ancho del contenedor
    zIndex: 100, // Establece el índice Z para el apilamiento de los elementos
  };

  // Define los estilos para el texto en el pie de la tarjeta
  const textStyles = {
    fontSize: '10px', // Establece el tamaño de la fuente
    color: '#cccccc', // Define el color del texto
    lineBreak: 'anywhere', // Permite el salto de línea en cualquier lugar
    wordBreak: 'normal', // Establece el comportamiento de corte de palabras
    overflow: 'hidden', // Oculta el contenido que excede los límites del contenedor
    whiteSpace: 'nowrap', // Evita que el texto se divida en varias líneas
    textOverflow: 'ellipsis', // Muestra puntos suspensivos cuando el texto es demasiado largo
    fontFamily: 'Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif', // Define la fuente del texto
    fontWeight: 100, // Establece el peso de la fuente
  };

  return (
    <>
      <Button onClick={() => navigate("/sonidos")}> {/* Botón que redirige a la página principal (ruta "/") al hacer clic */}
        <ArrowBackIosNewOutlinedIcon /> {/* Muestra el ícono de flecha hacia atrás dentro del botón */}
      </Button>
      <div
        id="koch-snowflake.head.166077097711" // Asigna un ID único al contenedor
        className="text resizable object" // Aplica clases CSS para estilo
        style={containerStyles} // Aplica los estilos al contenedor
      >
        <iframe
          style={iframeStyles} // Aplica los estilos al iframe
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1484903779&amp;color=%236c8cac&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true" // URL del reproductor de SoundCloud con parámetros configurados
          allow="autoplay" // Permite la reproducción automática del contenido
          title="SoundCloud player" // Título del iframe
        />
        <div style={textStyles}> {/* Contenedor para el texto que aparece debajo del reproductor */}
          <a
            href="https://soundcloud.com/labvs-imate-unam" // Enlace al perfil de SoundCloud
            title="labvs.imate.unam" // Título del enlace
            target="_blank" // Abre el enlace en una nueva pestaña
            rel="noopener noreferrer" // Seguridad para abrir el enlace
            style={{ color: '#cccccc', textDecoration: 'none' }} // Estilo del enlace (sin subrayado y color claro)
          >
            labvs.imate.unam {/* Texto del enlace (nombre del usuario de SoundCloud) */}
          </a> · 
          <a
            href="https://soundcloud.com/labvs-imate-unam/sets/koch-curve-iterations" // Enlace al track de SoundCloud titulado "Koch curve iterations"
            title="Koch curve iterations" // Título del enlace
            target="_blank" // Abre el enlace en una nueva pestaña
            rel="noopener noreferrer" // Seguridad para abrir el enlace
            style={{ color: '#cccccc', textDecoration: 'none' }} // Estilo del enlace (sin subrayado y color claro)
          >
            Koch curve iterations {/* Texto del enlace (nombre del track) */}
          </a>
        </div>
      </div>    
    </>
  );
}
